const r = "_container_r8r21_1", o = "_clickable_r8r21_9", _ = "_disabled_r8r21_12", c = "_small_r8r21_17", l = "_medium_r8r21_22", e = "_large_r8r21_27", a = "_circle_r8r21_32", n = {
  container: r,
  clickable: o,
  disabled: _,
  small: c,
  medium: l,
  large: e,
  circle: a,
  "color-brand": "_color-brand_r8r21_47",
  "color-gray": "_color-gray_r8r21_50",
  "color-warning": "_color-warning_r8r21_53",
  "color-success": "_color-success_r8r21_56",
  "color-error": "_color-error_r8r21_59",
  "color-white": "_color-white_r8r21_62",
  "color-hover-gray": "_color-hover-gray_r8r21_65",
  "color-transparent": "_color-transparent_r8r21_68"
};
export {
  a as circle,
  o as clickable,
  r as container,
  n as default,
  _ as disabled,
  e as large,
  l as medium,
  c as small
};
//# sourceMappingURL=index.es680.js.map
